var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{ fill:currentcolor;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/wallet-money"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/wallet-money_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet-money"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.97 16.58C20.73 19.25 18.8 21 16 21H7C4.24 21 2 18.76 2 16V9C2 6.28 3.64 4.38 6.19 4.06C6.45 4.02 6.72 4 7 4H16C16.26 4 16.51 4.01 16.75 4.05C19.14 4.33 20.76 6 20.97 8.42C21 8.71 20.76 8.95 20.47 8.95H18.92C17.96 8.95 17.07 9.32 16.43 9.98C15.67 10.72 15.29 11.76 15.38 12.8C15.54 14.62 17.14 16.05 19.04 16.05H20.47C20.76 16.05 21 16.29 20.97 16.58Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.0002 11.47V13.53C22.0002 14.08 21.5602 14.53 21.0002 14.55H19.0402C17.9602 14.55 16.9702 13.76 16.8802 12.68C16.8202 12.05 17.0602 11.46 17.4802 11.05C17.8502 10.67 18.3602 10.45 18.9202 10.45H21.0002C21.5602 10.47 22.0002 10.92 22.0002 11.47Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 32,
    height: 32
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.50cca2a16da380904002cbed14efa022.svg";
export { ForwardRef as ReactComponent };